<template>
  <div id="route" class="container-fluid" v-bind:class="{'webp': supportWebP, 'mobile': isMobile}">
<!--    v-bind:class="{'mobile': isMobile}"-->

<!--     <div class="container-fluid floating" v-if="playback" :key="video.sources[0].src">
        <div class="container">
            <button v-on:click="stop()" class="close"></button>
            <my-video class="trailer" v-if="playback" :sources="video.sources" :options="video.options"></my-video>
        </div>
    </div> -->


    <!--  -->
    <Alert :data="alertData" :show="alertDataShow" />
    <video-player v-if="playback" class="videoPlayer" :options="videoOptions"/>
    <template v-else>
      <flixMenu />
      <flixSlider />
      <flixSample />
      <flixFootSlider />
      <flixFaq />
      <flixFooter />
    </template>


  </div>
</template>

<script>
// import myVideo from 'vue-video'

const videoPlayer = () =>
    import(/* webpackChunkName: "video-player"*/ "./components/videoPlayer.vue");
// import videoPlayer from './components/videoPlayer.vue'
import flixMenu from './components/menu.vue'
import flixSlider from './components/slider.vue'
import flixSample from './components/free.vue'
import flixFootSlider from './components/flixFootSlider.vue'
import flixFaq from './components/faq.vue'
import flixFooter from './components/footer.vue'

const Alert = () =>
    import(/* webpackChunkName: "alert"*/ "./components/alert.vue");
// import Alert from './components/alert.vue'


import '@/assets/css/sweetalert2.css';

export default {
  name: 'route',
  components: {
    flixMenu,flixSlider,flixSample,flixFooter,flixFaq,Alert,flixFootSlider,videoPlayer
  },
  data(){ return {
      videoOptions: {
        autoplay: true,
        controls: true,
        fullscreen: false,
        controlBar: {
          fullscreenToggle: false
        },
        bufferingConfig: {
          includeScrub: true
        },
        plugins: { eventTracking: true },
        sources: [
          {
            src: null,
            type: 'application/x-mpegURL'
          },
        ]
      },
      playback: false,
      alertDataShow: false,
      alertData: {
        title: '',
        body: '',
        button: ''
      },
      video: {
            sources: [{
                src: '',
                type: 'video/mp4'
            }],
            options: {
                autoplay: true,
                volume: 0.6,
                poster: ''
            }
        },
      currentLang:'es',
      platform:'web',
      lang:{
        copyright: '',
        footerLinks: '',
        langToggle: '',
        freeTrial: '',
        login: '',
        demo: '',
        aboutUs: '',
        helpDesk: '',
         availableOn: '',
          multiplatform: '',
          enjoyEveryWhere: '',
          chooseYourPlan: '',
          signUp: '',
          signUpLead: '',
          pricePerMonth: '',
          pricePerYear: '',
          monthlyList: '',
          yearList: '',
          sampleTitle: '',
          HOMETEXT_TIMELINE_TODAY: '',
          HOMETEXT_TIMELINE_FULLFREE: '',
          HOMETEXT_TIMELINE_WELETYOUKNOW: '',
          HOMETEXT_TIMELINE_YOUCANCANCEL: '',
 
        slider:{
            img:{
              desktop:'',
              tablet:'',
              mobile:''        
            },
            caption:''
         },
         movies:{
          weekly:{
            genre:"", movies:[]
          },
          featured:{
            genre:"", movies:[]
          },
          editorsPicks:{
            genre:"", movies:[]
          },
       }

      },
       
    }
  },
  created: function () {
    this.currentLang = currentLang;
    this.lang = lang[this.currentLang];
    this.platform = lang.platform;
    // this.caption = lang.slider.caption;
    // this.img = lang.slider.img;
    this.isIos = lang.isIos;
    this.movies = lang.es.movies;
      
    // console.log(this.movies);
    // console.log(this.supportWebP);
    this.loadDeferredStyles();
    this.triggerPopup();
    this.viewportLock();
    
  },
  computed:{
    cuLang: function(){
      return '&lang='+this.currentLang;
    },
    cuLangAsk: function(){
      return '?lang='+this.currentLang;
    },
    supportWebP: function(){
      var ans = (window.hasWebp ? true : false);
      return ans;
    },
    showHead: function(){
      return ( this.platform == 'web' ? true:false);
    },
    showLogo: function(){
      return ( showLogo ? true:false);
    },
    isIpad: function() {
        const ua = window.navigator.userAgent;
        if (ua.indexOf('iPad') > -1) {
            return true;
        }

        if (ua.indexOf('Macintosh') > -1) {
            try {
                document.createEvent("TouchEvent");
                return true;
            } catch (e) {}
        }

        return false;
    },
    isMobile: function() {

      
    if(/ios|android/i.test(lang.platform)){
      return true
    }

     if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
       return true
     } else {
       return false
     }
   }
  },
  
  methods:{
    playBlackVideo: function(movie){

      this.videoOptions.sources[0].src = movie.urlplay;
      this.videoOptions.movie = movie
      this.playback = true

    },

    playBlackTrailer: function(movie){
      this.videoOptions.sources[0].src = movie.trailer;
      this.videoOptions.movie = movie
      this.playback = true

    },
    close: function (){
      this.videoOptions.sources[0].src = null
      this.playback = false
    },

    viewportLock: function(){


      if ((window.entry.indexOf("mobios.php") > -1) || (window.entry.indexOf("mob.php") > -1)) {
        var vpl = "width=device-width, initial-scale=1,maximum-scale=1.0, user-scalable=0";
        var vport = document.getElementById("vp");
        vport.content = vpl;
      }

    },
    launchSignup: function(movie){
      if (movie.type == "series"){
        this.alertData.title = this.lang.continueWatching.replace("%movie%",movie.title);
        this.alertData.body = this.lang.continueWatchingBody.replace("%movie%",movie.title);
        this.alertData.button = this.lang.continueWatchingButton.replace("%movie%",movie.title);
      }else{
        this.alertData.title = this.lang.continueWatchingMovie.replace("%movie%",movie.title);
        this.alertData.body = this.lang.continueWatchingMovieBody.replace("%movie%",movie.title);
        this.alertData.button = this.lang.continueWatchingMovieButton.replace("%movie%",movie.title);
      }
      this.alertDataShow = true;
    },
    triggerPopup: function(){

      if(this.lang.homePupuoStatus == 'active'){

        if (window.entry.indexOf("mobios.php") > -1) {
          return;
        }else if (window.entry.indexOf("mob.php") > -1) {
          return;
        }else{
          var myCookie = this.getCookie("fl_popup");
          if (myCookie == null) {
              var that = this;
              window._cmxthat = this;

                setTimeout(() =>{
                  this.alertData.title = that.lang.homePopupTitle;
                  this.alertData.body = that.lang.homePopupDescription;
                  this.alertData.button = that.lang.homePopupButton;

                  this.alertDataShow = true;

                  // that.$swal({
                  //   title: that.lang.homePopupTitle,
                  //   text: that.lang.homePopupDescription,
                  //   confirmButtonText: that.lang.homePopupButton,
                  //   showCloseButton: true
                  // }).then(function(value){
                  //   // that.lang.homePopupUrl
                  //   if(value.isConfirmed){
                  //     that.suscribe();
                  //   }
                  // });
                  // var closeButton = document.createElement('button');
                  // closeButton.className = 'swal2-close';
                  // closeButton.onclick = function() {  that.$swal.close(); };
                  // closeButton.textContent = '×';
                  // var modal = document.querySelector('.swal2-modal');
                  // modal.appendChild(closeButton);


                },parseInt(that.lang.homePopupTime));

          }
        }


      }


    },
    getCookie: function(name) {
      var dc = document.cookie;
      var prefix = name + "=";
      var begin = dc.indexOf("; " + prefix);
      if (begin == -1) {
          begin = dc.indexOf(prefix);
          if (begin != 0) return null;
      }
      else
      {
          begin += 2;
          var end = document.cookie.indexOf(";", begin);
          if (end == -1) {
          end = dc.length;
          }
      }
      // because unescape has been deprecated, replaced with decodeURI
      //return unescape(dc.substring(begin + prefix.length, end));
      return decodeURI(dc.substring(begin + prefix.length, end));
    },
    loadDeferredStyles: function(){

      // setTimeout(function(){
      //   var addStylesNode = document.getElementById("deferred-styles");
      //   var replacement = document.createElement("div");
      //   replacement.innerHTML = addStylesNode.textContent;
      //   document.body.appendChild(replacement)
      //   addStylesNode.parentElement.removeChild(addStylesNode);




        


      // },300);




    },
    png: function(src){
      if(window.hasWebp){
        var url = src.replace('.png','.webp');
        return url;
      }else{
        return src;
      }
    },
    img: function(src){
      if(window.hasWebp){
        var url = src+'.webp';
        return url;
      }else{
        return src;
      }
      
    },
    stop: function(){
      this.video.sources[0].src = null;

      this.video.options.poster = null;

      this.playback = false;
    },
    play: function(mov){
      console.log(mov);
      // this.video.sources[0].src = mov.video.replace('/1280x720.m3u8','/out.mp4');

      // this.video.options.poster = this.img(mov.thumb.replace('365_205/',''));

      // this.playback = true;
      window.location.href = "/titles/"+mov.slug;
    },
    login: function(){
      if (this.isMobile) {

        if (window.entry.indexOf("mobios.php") > -1) {
            window.webkit.messageHandlers.signUserIn.postMessage("login_js");
          return;
        }else if (window.entry.indexOf("mob.php") > -1) {
          JsHandler.login();
          return;
        }
        
      }
      window.location.href="/?l=loguser&lang="+this.currentLang;
      
    },
    suscribe: function(plan="monthly"){
      if (this.isMobile) {
        if (window.entry.indexOf("mobios.php") > -1) {
            window.webkit.messageHandlers.signUserIn.postMessage("reg_js");
          return;
        }else if (window.entry.indexOf("mob.php") > -1) {
          JsHandler.suscribe();
          return;
        }
      }
      window.location.href="/?l=registro/creatuusuario&plan="+plan+"&lang="+this.currentLang+"&utm_source=avod&utm_medium=post-watch-button&utm_campaign=avod";
      
    },
    langToggle: function(){

      let url = new URL(window.location);
      if(this.currentLang == 'es'){
        this.lang = lang['en'];
        this.currentLang = 'en';
        url.pathname = "/free/";
      }else{
        this.lang = lang['es'];
        this.currentLang = 'es';
        url.pathname = "/gratis/";
      }



      window.history.pushState({}, '', url);
       console.log('lang: langToggle');
      // this.$http.get('/?l=loguser&lang='+this.currentLang).then(function(response){
      //   console.log('resp: ',response);
      // }, function(response) {
      // });

    }
    

  }
  
}
</script>

